import { render, staticRenderFns } from "./semanticSearch.vue?vue&type=template&id=2b80d25f&scoped=true"
import script from "./semanticSearch.vue?vue&type=script&lang=js"
export * from "./semanticSearch.vue?vue&type=script&lang=js"
import style0 from "./semanticSearch.vue?vue&type=style&index=0&id=2b80d25f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b80d25f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b80d25f')) {
      api.createRecord('2b80d25f', component.options)
    } else {
      api.reload('2b80d25f', component.options)
    }
    module.hot.accept("./semanticSearch.vue?vue&type=template&id=2b80d25f&scoped=true", function () {
      api.rerender('2b80d25f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/semanticSearch.vue"
export default component.exports